import { createContext, useContext } from 'react';

export interface ICristalContext {
  score: number;
  error?: string;
  setScore: (score: number) => void;
  loading?: boolean;
}

export const initialCristalContext: ICristalContext = {
  score: 0,
  setScore: () => {},
};

export const CristalContext = createContext<ICristalContext>(
  initialCristalContext,
);

export const useCristal = () => {
  const cristal = useContext(CristalContext);

  return cristal;
};
